/* globals angular, _ */
(function() {
  'use strict';

  function FilterVisibleCtrl (
    mdPanelRef,
    moment,
    localStorageService
  ) {
    var ctrl = this;
    ctrl.ignoradas = ctrl.filters.data && ctrl.filters.data.all || false
    ctrl.close = function () {
      mdPanelRef.close();
    };
    ctrl.showAll = function () {
      ctrl.filters.data = {};
      ctrl.filters.data.visible = true;
      ctrl.close();
    };
    function _trackEvents (actionName, actionValue) {
      var config = {
        type: 'issues',
        email: localStorageService.get('user').email,
        criteria: 'previsao-entrega',
        action: 'filter',
        actionName: actionName,
        actionValue: actionValue,
      };
    }
    ctrl.onSubmit = function (form) {

      if (form.$pristine) {
        ctrl.close();
        return;
      }

      ctrl.filters.data = {};
      if(ctrl.ignoradas) {
        ctrl.filters.data.all = true;
      } else {
        ctrl.filters.data.visible = true;
      }

      //var actionName, actionValue;
      //if (ctrl.filters.data.noPrazo) {
        //actionName = 'FilterSituationOnTime';
        //actionValue = true;
      //} else if (ctrl.filters.data.atrasada) {
        //actionName = 'FilterSituationLater';
        //actionValue = true;
      //}
      //if (
          //ctrl.filters.data.dataEntregaPrevistaInicio ||
          //ctrl.filters.data.dataEntregaPrevistaFim
        //) {
        //actionName = 'FilterDeliveryDate';
        //actionValue = ctrl.filters.data.dataEntregaPrevistaInicio + ' - '
          //+ ctrl.filters.data.dataEntregaPrevistaFim;
      //}
      //_trackEvents(actionName, actionValue);
      ctrl.close();
    };
  }

  angular
    .module('mandaeApp')
    .controller('FilterVisibleCtrl', FilterVisibleCtrl);
}());
